/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { StarcIdContext } from "../components/starc";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
const createId = (counter) => {
    return `__starc-${counter}`;
};
/**
 * @deprecated This hook is for legacy support of React 17 environments.
 * Please use React.useId() in React 18 and higher.
 */
export const useElementId = (id) => {
    const idRef = React.useContext(StarcIdContext);
    const [generatedId, setGeneratedId] = React.useState(createId(0));
    // SSR - set all ids to 0
    // First React render - keep as 0 to avoid id mismatch between client and server
    // First DOM render - update to real id
    // Should be replaced by React opaque id hook once stable
    useIsomorphicLayoutEffect(() => {
        idRef.current += 1;
        setGeneratedId(createId(idRef.current));
    }, [idRef]);
    if (id)
        return id;
    return generatedId.toString();
};
